"use client";

import { ReactNode, useMemo } from "react";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useTranslation } from "react-i18next";
import FormProvider from "@/libs/shared/providers/FormProvider";
import { useFeatureFlagsContext } from "@/libs/shared/providers/FeatureFlagsProvider";

type TermsFlagsModalProviderProps = {
  children: ReactNode;
};

const TermsFlagsModalProvider = ({
  children,
}: TermsFlagsModalProviderProps) => {
  const { flags: { gdpr } = {} } = useFeatureFlagsContext();
  const { t } = useTranslation();

  const validationSchema = useMemo(
    () =>
      yup.object().shape({
        gdpr: yup
          .boolean()
          .required(t("common:error:required") || "")
          .oneOf([true], t("common:error:required") || ""),
        terms: yup.boolean(),
      }),
    [t],
  );

  const options = useMemo(
    () => ({
      resolver: yupResolver(validationSchema) as any,
      mode: "onChange" as const,
      defaultValues: {
        gdpr,
        terms: true,
      },
    }),
    [validationSchema, gdpr],
  );

  return <FormProvider {...options}>{children}</FormProvider>;
};

export default TermsFlagsModalProvider;
